// Dependencies
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

// Models
import { OrganizationModel } from '../../../models/organization.model';
import { StudyModel } from '../../../models/study.model';

// Services
import { AppConfig } from '../../../app.config';
import { StudyImageRequestService } from '../../../services/study-image-request.service';
import { StudyContainerPageService } from '../../study-container-page/study-container-page.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'study-landing-page',
    templateUrl: './study-landing-page.html',
    styleUrls: ['./study-landing-page.scss']
})
export class StudyLandingPageComponent {
    constructor(
        private appConfig: AppConfig,
        private ngbModal: NgbModal,
        private router: Router,
        private studyContainerPageService: StudyContainerPageService,
        private studyImageRequestService: StudyImageRequestService,
        private translateService: TranslateService) {}


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {
    }


    //----------------------------------
    // Public Methods
    //----------------------------------

    getOrganizationName() {
        return this.studyContainerPageService.getProperty('organizationModel').getOrganizationName(false);
    }

    getStudyOpenDateFormatted() {
        return this.studyContainerPageService.getProperty('studyModel').get('opens_at').format('MMMM Do');
    }

    goToSurveyStartPage() {
        const queryParams = {};
        if (this.studyContainerPageService.organizationIdParam) {
            queryParams['organization_id'] = this.studyContainerPageService.organizationIdParam;
        }

        this.router.navigate([`/${this.studyContainerPageService.studySlugParam}/start`], { queryParams });
    }

    openVideo(content) {
        this.ngbModal.open(content, {
            windowClass: 'vimeo-modal',
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/study-landing-page/study-landing-page.component.ts